import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Fetch } from "../../shared/Fetch";

interface NoteProps {
    open: boolean;
    singleData: any;
    onClose: () => void;
    toast: any;
}

export const Note = (props: NoteProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: any[], loading: boolean });
    const [value, setValue] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Mast/fetchConsultantbyID", "GET", null, `consultantID=${props.singleData.consultant_ID}`, props.toast);
        if (response) {
            const data: any[] = await response.json();
            setTableData({ tableData: data, loading: false });
        }
        else {
            setTableData({ tableData: tableData.tableData, loading: false });
        }
    }

    const addComment = async () => {
        if (!value || value.trim() === '') {
            props.toast?.current?.show({ severity: 'warn', summary: 'Warning', detail: 'Comment cannot be empty' });
        } else {
            setLoading(true);
            const body = {
                consultant_ID: props.singleData.consultant_ID,
                comments: value,
            };

            const response = await Fetch("Consultant_Mast/addEditConsultantNote", "POST", body, null, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: 'Comment Added Successfully', life: 3000 });
                setValue('');
                setLoading(false);
            } else setLoading(false);
        }
    }

    const onClose = () => {
        setValue('');
        setLoading(false);
        setTableData({ tableData: [], loading: false });
        props.onClose();
    }

    const onClear = () => {
        setValue('');
    }

    useEffect(() => {
        if (props.open && props.singleData.consultant_ID) {
            loadTableData();
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add Comment" modal className="p-fluid" onHide={onClose}>
            <DataTable style={{ border: '1px solid rgba(0, 0, 0, 0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData} lazy dataKey="consultant_ID"
                emptyMessage="No Details found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                loading={tableData.loading}
            >
                <Column field="consultant_ID" header="ID" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="consultant_Job_Title" header="Job Title" />
                <Column field="conStatus" header="Status" />
                <Column field="consRelocation" header="Relocation" />
            </DataTable>
            <div className="mt-5">
                <h3>Add Your Comments</h3>
                <InputTextarea value={value} onChange={(e) => setValue(e.target.value)} rows={5} cols={30} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button loading={loading} disabled={loading} form="requirementForm" label="SAVE" type={"button"} style={{ width: '100px' }} onClick={addComment} ></Button>
                    <Button className="p-button-outlined surface-200" style={{ width: '100px' }} label="CLEAR" onClick={onClear} type="button" ></Button>
                </div>
            </div>
        </Dialog>
    );
}

